import { createEvent, createStore } from 'effector'

const STORAGE_KEY = 'signedContractsReportFilters'

type FilterValue = 'all' | 'yes' | 'no'

export interface SignedContractsFilters {
  isAccountPaid: boolean | null
  isContractReturnedByClient: boolean | null
}

const readFiltersFromStorage = (): {
  isAccountPaid: FilterValue
  isContractReturned: FilterValue
} | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    const parsed = JSON.parse(raw)
    return {
      isAccountPaid: parsed.isAccountPaid ?? 'all',
      isContractReturned: parsed.isContractReturned ?? 'all'
    }
  } catch {
    return null
  }
}

const storedFilters = readFiltersFromStorage()

export const $isAccountPaidFilter = createStore<FilterValue>(
  storedFilters?.isAccountPaid ?? 'all'
)
export const $isContractReturnedFilter = createStore<FilterValue>(
  storedFilters?.isContractReturned ?? 'all'
)

export const setIsAccountPaidFilter = createEvent<FilterValue>()
export const setIsContractReturnedFilter = createEvent<FilterValue>()

$isAccountPaidFilter.on(setIsAccountPaidFilter, (_, value) => value)
$isContractReturnedFilter.on(setIsContractReturnedFilter, (_, value) => value)

$isAccountPaidFilter.watch((value) => {
  const current = readFiltersFromStorage()
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      isAccountPaid: value,
      isContractReturned: current?.isContractReturned ?? 'all'
    })
  )
})

$isContractReturnedFilter.watch((value) => {
  const current = readFiltersFromStorage()
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      isAccountPaid: current?.isAccountPaid ?? 'all',
      isContractReturned: value
    })
  )
})

const parseFilterValue = (value: FilterValue): boolean | null => {
  if (value === 'yes') return true
  if (value === 'no') return false
  return null
}

export const buildSignedContractsFilters = (
  isAccountPaid: FilterValue,
  isContractReturned: FilterValue
): SignedContractsFilters => ({
  isAccountPaid: parseFilterValue(isAccountPaid),
  isContractReturnedByClient: parseFilterValue(isContractReturned)
})
